import { motion } from "framer-motion";
import Image from '../../assets/Feedback/clgImage.jpg'
import { useState } from "react";
import SidebarGalleryPage from "../Main/Sidebargallery";


const Employer = () => {
  const [comment, setComment] = useState('')

  const questions = [
    'विद्यार्थी के व्यक्तित्व पर संस्था का योगदान',
    'व्यवसायिक दृष्टिकोण से डिप्लोमा का प्रभाव',
    'शिक्षकों की उपलब्धता',
    'संस्था के साथ आपका अनुभव',
    'संस्था में उपलब्ध अन्य सुविधायें'
  ]

  const [branch, setBranch] = useState('')
  const [session, setSession] = useState('')
  const [subject, setSubject] = useState('')

  return (
    <div className="min-h-screen bg-gray-100 p-12">
      {/* Main Content */}
      <div className="flex flex-col lg:flex-row gap-10">
      <div className="md:col-span-2">
          <img
            src={Image}
            alt="कॉलेज भवन"
            width={800}
            height={300}
           className="w-full h-auto border-4 border-[#00BFA5] rounded-lg p-2 mb-10"
          />
        
        <div className="p-2 border-4 border-teal-500 rounded-lg mb-10">
            <h1 className="text-xl text-white rounded-sm bg-teal-500 font-bold p-2 mb-4">नियोक्ता / रोजगार प्रदाता के लिए फीडबैक फॉर्म</h1>
          <div className="mb-6 space-y-4">
            <p>मान्यवर,</p>
            <p>सादर प्रणाम,</p>
            <p>महोदय,</p>
            <p>
            शासकीय महिला पॉलिटेक्निक महाविद्यालय सीहोर (म.प्र.) के पास-आउट विद्यार्थियों को आप
              रोजगार के अवसर प्रदान करते रहे हैं। आपके संस्थान में कार्य कर रहे हमारे पास-आउट विद्यार्थियों के संबंध में
              आपका अभिमत हमें हमारी शैक्षणिक गुणवत्ता सुधारने में मदद करेगा।
            </p>
            <div className="text-right">
            <p>प्राचार्य,</p>
              <p>शासकीय महिला पॉलिटेक्निक महाविद्यालय,</p>
              <p>सीहोर (म.प्र.)</p>
            </div>
          </div>
        </div>

      {/* <hr className="my-6 border-t border-gray-300" /> */}

      <div className="mt-10 mb-10 border-4 border-teal-500 p-2 rounded-lg">
      <h2 className="mb-4 text-xl font-bold bg-teal-500 text-white p-2 rounded-sm">निर्देश</h2>
        <p className="mb-2">प्रिय नियोक्ता,</p>
        <p className="mb-4">
          कृपया निम्नलिखित दिये गये विचारणीय बिन्दुओं पर अपने विचार दिए गए बिंदुओं में से किसी एक पर क्लिक
          करके देने का कष्ट करें।
        </p>
        <ol className="space-y-2 list-decimal list-inside">
          <li>यदि आप समझते हैं कि यह व्यवस्था आपके द्वारा आज तक देखी गई व्यवस्थाओं में सबसे बेहतर है तो कृपया
            <span className="font-bold"> "सर्वोत्तम"</span> पर क्लिक करिये।
          </li>
          <li>यदि आप समझते हैं कि यह व्यवस्था आपके द्वारा देखी गई व्यवस्थाओं में सर्वोत्तम तो नहीं किन्तु
            <span className="font-bold"> "उत्तम"</span> है तो कृपया उत्तम पर क्लिक करिये।
          </li>
          <li>यदि आप समझते हैं कि यह व्यवस्था उत्तम तो नहीं है किन्तु खराब भी नहीं है तो कृपया
            <span className="font-bold"> "संतोषजनक"</span> पर क्लिक करिये।
          </li>
          <li>यदि आप समझते हैं कि यह व्यवस्था खराब है इसमें सुधार करना है तो कृपया
            <span className="font-bold"> "असंतोषजनक"</span> पर क्लिक करिये।
          </li>
          <li>यदि आप समझते हैं कुछ भी कहना नहीं चाहते है तो कृपया
            <span className="font-bold"> "कोई टिप्पणी नहीं"</span> पर क्लिक करिये।
          </li>
          <li>किसी बिन्दु के बारे में आपको कोई जानकारी नहीं है तो कृपया
            <span className="font-bold"> "कोई टिप्पणी नहीं"</span> पर पर क्लिक करिये।
          </li>
        </ol>
      </div>

      <div className="p-2 mb-4 border-4 border-teal-500 rounded-lg ">
          <h2 className="text-xl text-white bg-teal-500 font-bold p-2 rounded-sm mb-4">Feedback Form</h2>
          {/* Add your form fields here */}
          <form className="space-y-6">
            {/* Example form field - repeat this structure for all required questions */}
            <div>
              <label className="block mb-2">1. क्या आप संस्था के पास-आउट विद्यार्थियों की कार्य क्षमता से संतुष्ट हैं?</label>
              <div className="space-x-4">
                <label className="inline-flex items-center">
                  <input type="radio" name="question1" value="सर्वोत्तम" className="form-radio" />
                  <span className="ml-2">सर्वोत्तम</span>
                </label>
                <label className="inline-flex items-center">
                  <input type="radio" name="question1" value="उत्तम" className="form-radio" />
                  <span className="ml-2">उत्तम</span>
                </label>
                <label className="inline-flex items-center">
                  <input type="radio" name="question1" value="संतोषजनक" className="form-radio" />
                  <span className="ml-2">संतोषजनक</span>
                </label>
                <label className="inline-flex items-center">
                  <input type="radio" name="question1" value="असंतोषजनक" className="form-radio" />
                  <span className="ml-2">असंतोषजनक</span>
                </label>
                <label className="inline-flex items-center">
                  <input type="radio" name="question1" value="कोई टिप्पणी नहीं" className="form-radio" />
                  <span className="ml-2">कोई टिप्पणी नहीं</span>
                </label>
              </div>
            </div>

            {/* Add more questions here following the same structure */}

            <div>
              <label htmlFor="comment" className="block mb-2">अन्य कोई सुझाव/टिप्पणी</label>
              <textarea
                id="comment"
                className="w-full p-2 border border-gray-300 rounded"
                rows={4}
                placeholder="यहाँ लिखें"
              ></textarea>
            </div>

            <button
              type="submit"
              className="px-4 py-2 text-black transition duration-200 bg-gray-300 rounded hover:bg-teal-500"
            >
              फीडबैक फॉर्म जमा करें
            </button>
          </form>
      </div>   
    </div>

        
       {/* gallery */}
      <SidebarGalleryPage/>
      </div>
      </div>
  );
};

export default Employer;
